import React, { Fragment, useEffect, useState } from 'react';
import { Box } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { MainDrawer } from '../../../CommonComponent/MainDrawer';
import { CreateSkill } from './CreateSkill';
import { skillDrawerDataApi, skillDrawerPost } from '../../../../../action/adminSettings';
import { useDispatch } from 'react-redux';
import { useSnackbar } from 'notistack';

export const SkillDrawer: React.FC<any> = (props: any) => {
	const { skillDrawerOpen, setSkillDrawerOpen, handleSaveSkill } = props;
	const { t } = useTranslation();
	const [skillDrawerData, setSkillDrawerData] = useState<any>({});
	const [formPostData, setFormPostData] = useState<any>({
		name: '',
		description: '',
		skillType: 0,
		isInDemand: false,
		status: 0,
		skillFrameworkId: 0,
		recommendedCourse: '',
		parentLevel: 0,
		parentLevelId: 0,
		proficiencyMapping: [],
	});
	const [formValidateData, setFormValidateData] = useState<any>({
		name: '',
		description: '',
		skillType: 0,
		isInDemand: false,
		status: 0,
		skillFrameworkId: 0,
		recommendedCourse: '',
		parentLevel: 0,
		parentLevelId: 0,
		proficiencyMapping: [],
	});
	const dispatch = useDispatch();
	const { enqueueSnackbar } = useSnackbar();

	useEffect(() => {
		getMaterSkillData();
	}, []);
	const getMaterSkillData = async () => {
		try {
			const response: any = await dispatch(skillDrawerDataApi());
			if (response) {
				if (response && response.data && response.data.status === 200) {
					setSkillDrawerData(response.data.entity || {});
					let proficiencyMapping = [...response.data.entity.skillFrsmworkProficiencyResponses];
					setFormPostData({
						...formPostData,
						parentLevel: response.data.entity.levelId,
						skillFrameworkId: response.data.entity.skillFrameworkId,
						proficiencyMapping: proficiencyMapping,
					});
				} else {
				}
			}
		} catch (e) {
			console.error(e);
		}
	};

	const handleDrawerClose = (event: any, type: string) => {
		if (type === 'save') {
			handleSave();
		}else{
		setSkillDrawerOpen(false);}
	};

	const showApiMsgs = (msg: string, variant: any) => {
		enqueueSnackbar(msg, {
			variant: variant,
			autoHideDuration: 5000,
		});
	};
	const handleSave = async () => {
		try {
			let formValidateDataCopy = { ...formValidateData };
			let isError = false;
			if (!formPostData.name || formPostData.name.trim() === '') {
				formValidateDataCopy.name = 'NameRequired';
				isError = true;
			}
			if (!formPostData.parentLevelId || formPostData.parentLevelId === 0 || formPostData.parentLevelId === '') {
				formValidateDataCopy.parentLevelId = 'Parent Level Required';
				isError = true;
			}
			if (isError) {
				setFormValidateData(formValidateDataCopy);
				return false;
			}
			console.log(formPostData);
			let formPostCopy = { ...formPostData };
			formPostCopy.proficiencyMapping = formPostCopy.proficiencyMapping.map((item: any) => {
				return {
					proficiencyScaleId: item.proficiencyScaleId,
					proficiencyDescription: item.proficiencyDescription || '',
					courseSuggestions: '',
					skillRoleMapping: item?.performanceRoleResponsesUsers
						? item?.performanceRoleResponsesUsers?.map((item1: any) => {
								return {
									assignmentType: 1,
									assignmentId: item1.performanceRoleId,
								};
						  })
						: [],
				};
			});
			const response: any = await dispatch(skillDrawerPost(formPostCopy));
			if (response) {
				if (response && response.data && response.data.status === 200) {
					handleSaveSkill();
					showApiMsgs(response?.data?.messageList?.messageSuccess, 'success');
					setSkillDrawerOpen(false);

				} else {
					showApiMsgs(response?.data?.messageList.message, 'error');
					return false;
				}
			}
		} catch (e) {
			console.error(e);
		}
	};

	return (
		<>
			<MainDrawer
				open={skillDrawerOpen}
				transitionDuration={{ enter: 500, exit: 1000 }}
				headerTitle={t('Add Skill')}
				children={
					<Box className='drawer-inner-content'>
						<CreateSkill
							{...props}
							skillDrawerData={skillDrawerData}
							setSkillDrawerData={setSkillDrawerData}
							formPostData={formPostData}
							setFormPostData={setFormPostData}
							formValidateData={formValidateData}
							setFormValidateData={setFormValidateData}
						/>
					</Box>
				}
				saveButtonText={t('saveBtn')}
				handleDrawerClose={(event: any) => handleDrawerClose(event, 'close')}
				handleSaveClick={(event: any) => handleDrawerClose(event, 'save')}
				handleCancelClick={(event: any) => handleDrawerClose(event, 'cancel')}
			/>
		</>
	);
};
